import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { userPaymentsApi } from "api/userPaymentsApi";

export const useUserPayments = (userId: number, courseId: number) => {
  return useQuery({
    queryKey: QUERIES_KEYS.USER_PAYMENTS(userId, courseId),
    queryFn: () => userPaymentsApi.fetch(userId, courseId),
    enabled: !!(userId && courseId),
  });
};
